/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_WeightInputs */

const vi_product_weight = /** @type {(inputs: Product_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trọng lượng`)
};

/**

* @param {Product_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_weight = /** @type {((inputs?: Product_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_weight(inputs)
});